<div class="tw-flex tw-flex-col tw-items-start" [class.card-container-grey]="!withShadow" [class.card-container-shadow]="withShadow">
  <p class="tw-text-lg tw-text-gray-700 tw-font-semibold truncate">Jefferson Gutierrito</p>
  <i nz-icon nzType="info-circle" class="tw-text-xs tw-cursor-pointer info-icon" nzTheme="outline" nz-popover="" nzPopoverTitle=""
    nzPopoverContent="Usuario sin registro"></i>
  <p class="tw-text-sm tw-text-gray-700">Ha solicitado una cita:</p>
  <div class="tw-mt-3 tw-flex tw-items-start">
    <img [src]="'./../../../assets/images/icons/' + (type === 'online' ? 'icons8-video-call-100.png' : 'icons8-sitting-on-chair-100.png')" alt=""
      class="tw-w-9 appointment-type">
    <div class="tw-flex tw-flex-col">
      <p class="tw-text-sm tw-text-gray-700">{{ type === 'online' ? 'En línea' : 'Presencial'}}</p>
      <p class="tw-text-xs tw-text-gray-500">19 de Junio del 2022, 10:30 am</p>
    </div>
  </div>
  <div class="tw-p-1 tw-mt-3 tw-border-0 tw-border-l-2 tw-border-gray-600 tw-border-solid">
    <p class="tw-text-gray-600 tw-text-sm" appExpandText maxCharacters="50">Bajar de peso y controlar la diabetes grado II peso y controlar la
      diabetes grado III</p>
  </div>
  <div class="button tw-flex tw-justify-end tw-w-full tw-gap-3 tw-mt-7">
    <button nz-button nzType="primary" nzDanger nzGhost>
      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
      rechazar
    </button>
    <button nz-button nzType="primary">
      <i nz-icon nzType="check-circle" nzTheme="outline"></i>
      aceptar
    </button>
  </div>
</div>

<!--
nombre
en line o presencial
fecha y la hora de la cita solicitada
el un paciente registrado o no
-->
